import { RecipientSelectorModal } from './RecipientSelectorModal'

type Props = {
  show: boolean
  onHide: () => void
  onSubmit: (payload: { contactId: string }[]) => Promise<void>
  loading?: boolean
  campaignName?: string
}

export const AddTargetModal = ({ show, onHide, onSubmit, loading, campaignName }: Props) => {
  const handleSelectRecipients = async (selectedIds: string[]) => {
    // Transform IDs to the expected payload format
    // Note: We are losing the per-target metadata/overrides capability here in favor of the requested UI.
    // If needed, we can re-introduce a step to add metadata after selection, or add global metadata.
    const targets = selectedIds.map(id => ({
      contactId: id
    }))

    await onSubmit(targets)
    onHide()
  }

  // Reuse RecipientSelectorModal directly
  return (
    <RecipientSelectorModal
      show={show}
      onHide={onHide}
      onSave={handleSelectRecipients}
      initialSelectedIds={[]} // Always start fresh for "Add target"
      confirmLabel={loading ? 'Adding...' : 'Add targets'}
    />
  )
}
